import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function PrixParMateriau() {
  const { t } = useTranslation('blogprix');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  const navigateTo = (path: string) => {
    if (window.REACT_APP_NAVIGATE) window.REACT_APP_NAVIGATE(path);
  };

  return (
    <section ref={ref} id="materiau" className="scroll-mt-28">
      <h2 className={`font-manrope font-bold text-slate-primary text-xl md:text-2xl lg:text-3xl mb-8 transition-all duration-1000 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
      }`}>
        {t('materiau_h2')}
      </h2>

      <div className="space-y-10">
        {/* Bardeau */}
        <div className={`transition-all duration-1000 delay-150 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}
        >
          <h3 className="font-manrope font-bold text-slate-primary text-lg md:text-xl mb-3">{t('materiau_1_h3')}</h3>
          <p className="text-slate-primary/70 text-sm md:text-base leading-relaxed mb-4">{t('materiau_1_intro')}</p>
          <div className="space-y-3 bg-soft-gray rounded-lg p-5">
            <div>
              <p className="font-semibold text-slate-primary text-sm">{t('materiau_1_gamme_1_label')}</p>
              <p className="text-slate-primary/60 text-sm">{t('materiau_1_gamme_1_desc')}</p>
            </div>
            <div>
              <p className="font-semibold text-slate-primary text-sm">{t('materiau_1_gamme_2_label')}</p>
              <p className="text-slate-primary/60 text-sm">{t('materiau_1_gamme_2_desc')}</p>
            </div>
            <div>
              <p className="font-semibold text-slate-primary text-sm">{t('materiau_1_gamme_3_label')}</p>
              <p className="text-slate-primary/60 text-sm">{t('materiau_1_gamme_3_desc')}</p>
            </div>
          </div>
          <p className="text-slate-primary/60 text-sm mt-3 italic">{t('materiau_1_note')}</p>
          <button
            onClick={() => navigateTo('/bardeau-asphalte')}
            className="mt-3 text-copper text-sm font-semibold hover:underline flex items-center gap-1"
          >
            {t('materiau_1_cta')} <i className="ri-arrow-right-line" />
          </button>
        </div>

        {/* Membrane */}
        <div className={`transition-all duration-1000 delay-200 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}
        >
          <h3 className="font-manrope font-bold text-slate-primary text-lg md:text-xl mb-3">{t('materiau_2_h3')}</h3>
          <p className="text-slate-primary/70 text-sm md:text-base leading-relaxed mb-4">{t('materiau_2_intro')}</p>
          <ul className="space-y-2 bg-soft-gray rounded-lg p-5 list-disc list-inside">
            <li className="text-slate-primary/70 text-sm">{t('materiau_2_item_1')}</li>
            <li className="text-slate-primary/70 text-sm">{t('materiau_2_item_2')}</li>
            <li className="text-slate-primary/70 text-sm">{t('materiau_2_item_3')}</li>
          </ul>
          <p className="text-slate-primary/60 text-sm mt-3 italic">{t('materiau_2_note')}</p>
          <button
            onClick={() => navigateTo('/toit-plat-membrane-elastomere')}
            className="mt-3 text-copper text-sm font-semibold hover:underline flex items-center gap-1"
          >
            {t('materiau_2_cta')} <i className="ri-arrow-right-line" />
          </button>
        </div>

        {/* Tôle */}
        <div className={`transition-all duration-1000 delay-300 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}
        >
          <h3 className="font-manrope font-bold text-slate-primary text-lg md:text-xl mb-3">{t('materiau_3_h3')}</h3>
          <p className="text-slate-primary/70 text-sm md:text-base leading-relaxed mb-4">{t('materiau_3_intro')}</p>
          <ul className="space-y-2 bg-soft-gray rounded-lg p-5 list-disc list-inside">
            <li className="text-slate-primary/70 text-sm">{t('materiau_3_item_1')}</li>
            <li className="text-slate-primary/70 text-sm">{t('materiau_3_item_2')}</li>
            <li className="text-slate-primary/70 text-sm">{t('materiau_3_item_3')}</li>
          </ul>
          <p className="text-slate-primary/60 text-sm mt-3 italic">{t('materiau_3_note')}</p>
          <button
            onClick={() => navigateTo('/toiture-tole-metal')}
            className="mt-3 text-copper text-sm font-semibold hover:underline flex items-center gap-1"
          >
            {t('materiau_3_cta')} <i className="ri-arrow-right-line" />
          </button>
        </div>

        {/* Pose complète vs recouvrement */}
        <div className={`transition-all duration-1000 delay-400 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}
        >
          <h3 className="font-manrope font-bold text-slate-primary text-lg md:text-xl mb-3">{t('materiau_4_h3')}</h3>
          <div className="space-y-3">
            <p className="text-slate-primary/70 text-sm md:text-base leading-relaxed">{t('materiau_4_p1')}</p>
            <p className="text-slate-primary/70 text-sm md:text-base leading-relaxed">{t('materiau_4_p2')}</p>
            <p className="text-slate-primary/70 text-sm md:text-base leading-relaxed">{t('materiau_4_p3')}</p>
          </div>
        </div>
      </div>
    </section>
  );
}